module.exports = __webpack_public_path__ + "static/media/binoculars.681c3d65.png";